var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2105_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.739 3.28425L10.1174 1.54321L9.77965 0.860442C9.55865 0.416647 9.01963 0.233379 8.57583 0.454378L2.86578 3.28425H3.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0975 1.59351C12.0184 1.59351 11.9394 1.60429 11.8603 1.62585L10.3618 2.0355L5.78552 3.28424H10.9799H13.2438L12.9635 2.2565C12.8557 1.85583 12.4928 1.59351 12.0975 1.59351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1799 3.91309H13.9751H13.6966H13.4181H11.2925H3.48209H2.45795H1.59551H1.4356H0.900168C0.616283 3.91309 0.362942 4.04425 0.197642 4.25087C0.122179 4.3461 0.0646828 4.4557 0.0323414 4.57608C0.0125772 4.65155 0 4.7306 0 4.81146V4.91926V5.94341V14.8211C0 15.317 0.402471 15.7195 0.898372 15.7195H14.1781C14.674 15.7195 15.0765 15.317 15.0765 14.8211V12.3147H9.74554C8.90286 12.3147 8.2183 11.6301 8.2183 10.7874V9.96452V9.68602V9.40753V8.78945C8.2183 8.3762 8.38359 8.0007 8.65132 7.72579C8.88849 7.48142 9.20651 7.31612 9.56227 7.27479C9.62156 7.26762 9.68265 7.26401 9.74374 7.26401H14.329H14.6075H14.886H15.0765V4.81146C15.0783 4.31556 14.6758 3.91309 14.1799 3.91309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7071 8.12293C15.6173 8.04028 15.5113 7.97739 15.3927 7.93607C15.3011 7.90554 15.204 7.88757 15.1016 7.88757H15.0783H15.0603H14.7818H13.7774H9.74554C9.24962 7.88757 8.84717 8.29003 8.84717 8.78594V9.23332V9.51181V9.79031V10.7857C8.84717 11.2816 9.24962 11.6841 9.74554 11.6841H15.0783H15.1016C15.204 11.6841 15.3011 11.6661 15.3927 11.6356C15.5113 11.596 15.6173 11.5314 15.7071 11.4487C15.8868 11.2852 16 11.048 16 10.7857V8.78594C16 8.5236 15.8868 8.28641 15.7071 8.12293ZM11.6213 9.96459C11.6213 10.2125 11.4201 10.4138 11.1722 10.4138H10.8739C10.6259 10.4138 10.4247 10.2125 10.4247 9.96459V9.66633C10.4247 9.52259 10.4912 9.39501 10.5972 9.31415C10.6745 9.25486 10.7697 9.21715 10.8739 9.21715H10.9494H11.1722C11.4201 9.21715 11.6213 9.41836 11.6213 9.66633V9.96459Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2105_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bd7c3497891e3f2a5780864e8bd46f0c.svg";
export { ForwardRef as ReactComponent };